export const enviroments = {
    apiUrl: 'https://api.rd.services/platform/',
    apiKey: '9d9b6c15b2de5cee808b92f81483f96c',
    backendApi: 'https://kq7oo5ky4h.execute-api.us-east-1.amazonaws.com'   
}
